"use client";
import * as React from "react";
const SvgCodeRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 10", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5.245 8.255 1.989 4.999l3.256-3.256a.821.821 0 0 0 0-1.169.821.821 0 0 0-1.169 0L.244 4.406a.831.831 0 0 0 0 1.177l3.832 3.84a.821.821 0 0 0 1.169 0 .821.821 0 0 0 0-1.168Zm5.51 0 3.256-3.256-3.256-3.256a.821.821 0 0 1 0-1.169.821.821 0 0 1 1.169 0l3.832 3.832a.831.831 0 0 1 0 1.177l-3.832 3.84a.821.821 0 0 1-1.169 0 .821.821 0 0 1 0-1.168Z" }));
export {
  SvgCodeRound as default
};
